<template>
	<div class="full">
		<el-container class="full">
			<el-container>
				<el-aside width="200px">
					<stafftree-index v-if="sourceData" :key="stafftreeKey" :sourceData="sourceData" @select = "stafftreeChange" />
				</el-aside>
				<el-container>
					<el-main>
						<div class="table">
							<vxe-form :data="formData" @submit="submitEvent" @reset="reset">
								<vxe-form-item title="店铺名称" field="shopname">
									<template #default="{ data }">
										<el-cascader v-model="data.shopname" size="mini" collapse-tags
											:options="shopnameOptions" :show-all-levels="false"
											:props="{ multiple: true, checkStrictly: false }" clearable></el-cascader>
									</template>
								</vxe-form-item>
								<vxe-form-item title="日期" field="shopname">
									<template #default="{ data }">
										<datePicker :sequence="false" v-model="data.date" />
									</template>
								</vxe-form-item>
								<vxe-form-item>
									<template #default>
										<vxe-button type="submit" status="primary">查询</vxe-button>
										<vxe-button type="reset">重置</vxe-button>
									</template>
								</vxe-form-item>
							</vxe-form>
							<vxe-toolbar ref="toolbar" export refresh custom>
								<template #buttons>
									<datePicker :sequence="false" type="date" v-model="downloaddate" />
									<vxe-button style="margin-left: 10px;" @click="downloadcurentday" status="primary">
										日数据下载</vxe-button>
									<vxe-button style="margin-left: 10px;" @click="performance" status="danger">
										战绩报表</vxe-button>
									<vxe-button style="margin-left: 10px;" @click="clickfarming" status="warning">
										刷单金额</vxe-button>	
								</template>
							</vxe-toolbar>
							<vxe-table v-if="staticStaff.length==0" border :loading="loading"
								:row-config="{isCurrent: true, isHover: true}" id="bi_bisummary"
								@cell-click="cellClickEvent" @header-cell-click="headerCellClickEvent" ref="bisummary"
								:data="tableData" max-height="70%" :column-config="{isCurrent: true, isHover: true}"
								:show-footer="true" :footer-method="footerMethod" :export-config="{}"
								:custom-config="customConfig"
								:tree-config="{transform: true, rowField: 'id', parentField: 'parentId', lazy: true, hasChild: 'hasChild', loadMethod: loadChildrenMethod}">
								<vxe-column fixed="left" field="departmentid" title="部门" tree-node>
									<template #default="{ row }">
										<span>{{$systemMethods.getdepartment(row.departmentid)}}</span>
									</template>
								</vxe-column>
								<vxe-column fixed="left" field="psnNickName" title="旺旺昵称	"></vxe-column>
								<vxe-column field="validReplyUv1d" title="有效接待人数" sortable></vxe-column>
								<vxe-column field="cstUsrCnt1d" title="询单人数" sortable></vxe-column>
								<vxe-column field="ordUsrCntFinalNd" title="最终下单人数" sortable></vxe-column>
								<vxe-column field="payAmt1d" title="销售额" sortable></vxe-column>
								<vxe-column field="rfdAmt1d" title="成功退款金额" sortable></vxe-column>
								<vxe-column field="realPayAmt1d" title="净销售额" sortable></vxe-column>
								<vxe-column field="fstReplyDur1d" title="首响" sortable></vxe-column>
								<vxe-column field="avgReplyDur1d" title="平响" sortable></vxe-column>
								<vxe-column field="conversionrate" title="转化率(%)" sortable>
									<template #default="{ row }">
										<span>{{row.conversionrate?parseFloat(row.conversionrate).toFixed(2):'0.00'}}</span>
									</template>
								</vxe-column>
								<vxe-column field="allCstSftRate" title="客户满意率(%)" sortable></vxe-column>
								<vxe-column field="resRecvEvaCnt1d" title="收到评价数" sortable></vxe-column>
								<vxe-column field="resLevel5Cnt1d" title="很满意数" sortable></vxe-column>
								<vxe-column field="resLevel4Cnt1d" title="满意数" sortable></vxe-column>
								<vxe-column field="onlineDuration" title="在线总时长(小时)" sortable></vxe-column>
								<vxe-column field="onlineDurationPerDay" title="平均日在线时长(小时)" sortable></vxe-column>
								<vxe-column field="dateId" title="最近日期"></vxe-column>
								<template v-if="showKpi">
									<vxe-column fixed="right" v-for="(item,index) in kpicontent" :field="item+'目标'"
										:title="item+'目标'" :key="index + Math.random()">
									</vxe-column>
									<vxe-column fixed="right" v-for="(item,index) in kpicontent" :field="item+'进度'"
										:title="item+'进度'" :key="index + Math.random()"></vxe-column>
								</template>
							</vxe-table>
							<vxe-table v-else border :loading="loading" :row-config="{isCurrent: true, isHover: true}"
								id="bi_bisummary" @cell-click="cellClickEvent" @header-cell-click="headerCellClickEvent"
								ref="bisummary" :data="tableData" max-height="70%"
								:column-config="{isCurrent: true, isHover: true}" :show-footer="true"
								:footer-method="footerMethod" :export-config="{}" :custom-config="customConfig">
								<vxe-column fixed="left" field="departmentid" title="部门">
									<template #default="{ row }">
										<span>{{$systemMethods.getdepartment(row.departmentid)}}</span>
									</template>
								</vxe-column>
								<vxe-column fixed="left" field="psnNickName" title="旺旺昵称"></vxe-column>
								<vxe-column field="validReplyUv1d" title="有效接待人数" sortable></vxe-column>
								<vxe-column field="cstUsrCnt1d" title="询单人数" sortable></vxe-column>
								<vxe-column field="ordUsrCntFinalNd" title="最终下单人数" sortable></vxe-column>
								<vxe-column field="payAmt1d" title="销售额" sortable></vxe-column>
								<vxe-column field="rfdAmt1d" title="成功退款金额" sortable></vxe-column>
								<vxe-column field="realPayAmt1d" title="净销售额" sortable></vxe-column>
								<vxe-column field="fstReplyDur1d" title="首响" sortable></vxe-column>
								<vxe-column field="avgReplyDur1d" title="平响" sortable></vxe-column>
								<vxe-column field="conversionrate" title="转化率(%)" sortable></vxe-column>
								<vxe-column field="allCstSftRate" title="客户满意率(%)" sortable></vxe-column>
								<vxe-column field="resRecvEvaCnt1d" title="收到评价数" sortable></vxe-column>
								<vxe-column field="resLevel5Cnt1d" title="很满意数" sortable></vxe-column>
								<vxe-column field="resLevel4Cnt1d" title="满意数" sortable></vxe-column>
								<vxe-column field="onlineDuration" title="在线总时长(小时)" sortable></vxe-column>
								<vxe-column field="onlineDurationPerDay" title="平均日在线时长(小时)" sortable></vxe-column>
								<vxe-column field="dateId" title="日期"></vxe-column>
							</vxe-table>
						</div>
						<div class="chart">
							<div class="full flex" style="flex-direction: column;">
								<el-checkbox-group size="mini" v-model="staticStaff" style="margin: 10px 0;">
									<el-checkbox-button v-for="(item,index) in staff" :key="index" :label="item">
										{{item}}</el-checkbox-button>
									<!-- 									<el-radio-button label="statistics">统计</el-radio-button>
									<el-radio-button label="trend">趋势</el-radio-button> -->
								</el-checkbox-group>
								<div style="flex: 1;position: relative;">
									<statistics-chart ref="statisticsChart" :kpi="kpi" :sourceData="sourceData"
										:tableData="tableData" :chartField="chartField" :staticStaff="staticStaff"
										:chartTitle="chartTitle" :date="date" :childrenRow="childrenRow" />
									<trend-chart ref="trendChart" v-if="false" :formData="formData"
										:chartField="chartField" :chartTitle="chartTitle" :trendData="trendData"
										:date="date" />
								</div>
							</div>
						</div>
					</el-main>
				</el-container>
			</el-container>
		</el-container>
		<performance-index :sourcedata="sourceData" :kpi="kpi" :param="param" ref="performanceIndex" />
		<clickfarming-index ref="clickfarmingIndex" />
	</div>
</template>
<style>

</style>
<style scoped>
	.table {
		position: relative;
		width: 100%;
		height: 60%;
	}

	.chart {
		position: relative;
		width: 100%;
		height: 40%;
	}
</style>
<script>
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	import statisticsChart from './statistics.vue'
	import trendChart from './trend.vue'
	import performanceIndex from './performance/index.vue'
	import clickfarmingIndex from './clickfarming/index.vue'
	import stafftreeIndex from './stafftree/tree.vue'
	export default {
		name: 'bi',
		props: {
			currenttab: {
				default: () => {
					return ''
				}
			}
		},
		data() {
			return {
				loading: false,
				stafftreeKey:Math.random(),
				downloaddate: null,
				staticField: ['validReplyUv1d', 'cstUsrCnt1d', 'ordUsrCntFinalNd', 'payAmt1d', 'rfdAmt1d', 'realPayAmt1d',
					'onlineDuration', 'resLevel5Cnt1d', 'resLevel4Cnt1d', 'resRecvEvaCnt1d'
				],
				filterField: ['psnNickName', 'shopname', 'dateId'],
				chartField: 'realPayAmt1d',
				chartTitle: '净销售额',
				staticStaff: [],
				sourceData: [],
				tableData: [],
				kpi: [],
				param:[],
				kpicontent: [],
				childrenRow: null,
				showKpi: true,
				trendData: [],
				staff: [],
				shopnameOptions: [],
				formField: {
					shopname: [],
					psnNickName: []
				},
				formData: {
					shopname: [],
					date: null
				},
				date: '',
				customConfig: {
					storage: true
				},
				
			}
		},
		watch: {
			staticStaff() {
				this.createChart()
			}
		},
		created() {

		},
		mounted() {
			this.currrentdate()
			this.list()
			this.$nextTick(() => {
				this.$refs.bisummary.connect(this.$refs.toolbar)
			})
		},
		computed: {

		},

		methods: {
			stafftreeChange(){
				
			},
			clickfarming(){
				this.$refs.clickfarmingIndex.modal_show()
			},
			performance(){
				this.$refs.performanceIndex.modal_show()
			},
			loadChildrenMethod({
				row
			}) {
				return new Promise((resolve) => {
					let column = this.$refs.bisummary.getTableColumn().fullColumn
					let sourceData = JSON.parse(JSON.stringify(this.sourceData))
					if (this.staticStaff.length == 0) {
						sourceData = sourceData.filter((item) => {
							return item.departmentid == row.departmentid
						})
						sourceData = this.$Lodash.orderBy(sourceData, ['dateId'], ['desc'])
					} else {
						// sourceData = sourceData.filter((item)=>{
						// 	return item.departmentid == row.departmentid
						// })
						// sourceData = this.$Lodash.orderBy(sourceData, ['dateId'], ['desc'])
					}
					let groupedData = this.$Lodash.groupBy(sourceData, 'psnNickName')
					// let currentData = groupedData[row.psnNickName]
					// groupedData = this.$Lodash.groupBy(currentData, 'shopname')
					let staticData = this.getStaticData(groupedData, 'psnNickName')
					let kpigroupedData = this.$Lodash.groupBy(this.kpi, 'content')
					for(let i in kpigroupedData){
						kpigroupedData[i] = this.$Lodash.groupBy(kpigroupedData[i], 'staffname')
					}
					//let kpigroupedData = this.$Lodash.groupBy(this.kpi, 'staffname')
					staticData.forEach((item) => {
						for(let i in kpigroupedData){
							if (kpigroupedData[i][item.psnNickName]) {
								let content = kpigroupedData[i][item.psnNickName][0].content
								let target = this.$Lodash.sumBy(kpigroupedData[i][item.psnNickName], item =>
									parseFloat(item.target))
								let targetcolumn = column.find((col) => {
									return col.title == content
								})
								item[content + '目标'] = target
								item[content + '进度'] = (item[targetcolumn.field] / target * 100).toFixed(2) +
									'%'
							}
						}
					})
					const childs = staticData
					childs.forEach((item) => {
						item.ischild = true
					})
					resolve(childs)
				})
			},
			list() {
				this.childrenRow = null
				this.loading = true
				let online = []
				let underline = []
				let param = JSON.parse(JSON.stringify(this.formData))
				param.shopname = param.shopname.map((item) => {
					return item[item.length - 1]
				})
				this.param = param
				this.$api.BIsummary.get(param).then((res) => {
					this.kpi = res.kpi
					this.sourceData = res.tableData
					this.formField = res.formField
					this.formField.shopname.forEach((item) => {
						if (item.label.includes('线下')) {
							underline.push(item)
						} else {
							online.push(item)
						}
					})
					this.shopnameOptions = [{
						value: '线上',
						label: '线上',
						children: online
					}, {
						value: '线下',
						label: '线下',
						children: underline
					}]
					this.stafftreeKey = Math.random()
					this.tableData = this.createTableData()

					//console.log(tableData)
					// console.log(param, 123123)


					// this.date = res.date

					this.createChart()

					this.createkpi(this.tableData)
					this.loading = false

				})


			},

			createTableData() {
				let tableData = []
				let sourceData = JSON.parse(JSON.stringify(this.sourceData))
				if (this.staff.length == 0) {
					sourceData.forEach((item) => {
						this.staff.push(item.psnNickName)
					})
				}
				this.staff = [...new Set(this.staff)]


				if (this.staticStaff.length == 0) {
					let groupedData = this.$Lodash.groupBy(sourceData, 'departmentid')
					tableData = this.getStaticData(groupedData, 'departmentid')
					tableData.forEach((item) => {
						item.parentId = 0
						item.hasChild = true
						item.shopname = '展开'
					})
				} else {
					sourceData = sourceData.filter((item) => {
						return this.staticStaff.includes(item.psnNickName)
					})
					let groupedData = this.$Lodash.groupBy(sourceData, 'dateId')
					for (let i in groupedData) {
						let _sourceData = JSON.parse(JSON.stringify(groupedData[i]))
						let _groupedData = this.$Lodash.groupBy(_sourceData, 'psnNickName')
						let _tableData = this.getStaticData(_groupedData, 'psnNickName')
						_tableData.forEach((item) => {
							item.parentId = 0
							item.hasChild = true
							item.shopname = '展开'
						})
						tableData = tableData.concat(_tableData)
					}
				}
				this.createkpi(tableData)
				return tableData
			},
			getStaticData(groupedData, keyfield) {
				let tableData = []
				let result = {}
				for (let key in groupedData) {
					let dates = []
					groupedData[key].forEach((item) => {
						dates.push(item.dateId)
					})
					dates = [...new Set(dates)]
					let obj = {}
					this.staticField.forEach((field) => {
						obj[field] = this.$Lodash.sumBy(groupedData[key], item => parseFloat(item[
							field]))
						obj[field] = obj[field].toFixed(2)
					})
					obj['validReplyUv1d*fstReplyDur1d'] = this.$Lodash.sumBy(groupedData[key], item =>
						parseFloat(item.validReplyUv1d * item.fstReplyDur1d))
					obj['validReplyUv1d*avgReplyDur1d'] = this.$Lodash.sumBy(groupedData[key], item =>
						parseFloat(item.validReplyUv1d * item.avgReplyDur1d))
					obj.fstReplyDur1d = obj['validReplyUv1d*fstReplyDur1d'] / obj.validReplyUv1d
					obj.fstReplyDur1d = isNaN(obj.fstReplyDur1d) ? 0 : obj.fstReplyDur1d.toFixed(2)
					obj.avgReplyDur1d = obj['validReplyUv1d*avgReplyDur1d'] / obj.validReplyUv1d
					obj.avgReplyDur1d = isNaN(obj.avgReplyDur1d) ? 0 : obj.avgReplyDur1d.toFixed(2)
					obj.conversionrate = obj.cstUsrCnt1d == 0 ? 0 : obj.ordUsrCntFinalNd / obj.cstUsrCnt1d * 100
					if (parseFloat(obj.resRecvEvaCnt1d)) {
						obj.allCstSftRate = (parseFloat(obj.resLevel5Cnt1d) + parseFloat(obj.resLevel4Cnt1d)) / parseFloat(
							obj.resRecvEvaCnt1d)
					} else {
						obj.allCstSftRate = 0
					}
					obj.allCstSftRate = (obj.allCstSftRate * 100).toFixed(2)


					obj.onlineDurationPerDay = (obj.onlineDuration / dates.length).toFixed(2)

					obj.dateId = groupedData[key][0]['dateId']
					obj.departmentid = groupedData[key][0]['departmentid']
					result[key] = obj
					//console.log(obj)
				}
				for (let i in result) {
					let dataitem = result[i]
					dataitem[keyfield] = i
					tableData.push(dataitem)
				}
				return tableData
			},



			createkpi(tableData) {
				let column = this.$refs.bisummary.getTableColumn().fullColumn
				
				this.kpi.forEach((item) => {
					if (!this.kpicontent.includes(item.content)) {
						this.kpicontent.push(item.content)
					}
				})
				//console.log(this.kpicontent,123123)
				let groupedData = this.$Lodash.groupBy(this.kpi, 'content')
				for(let i in groupedData){
					groupedData[i] = this.$Lodash.groupBy(groupedData[i], 'departmentid')
				}
				tableData.forEach((item) => {
					for(let i in groupedData){
						if (groupedData[i][item.departmentid]) {
							let content = groupedData[i][item.departmentid][0].content
							let target = 0
							if( content.includes("%") ){
								target = this.$Lodash.meanBy(groupedData[i][item.departmentid], item =>
									parseFloat(item.target))
							}else{
								target = this.$Lodash.sumBy(groupedData[i][item.departmentid], item =>
									parseFloat(item.target))
							}

							let targetcolumn = column.find((col) => {
								return col.title == content
							})						
							item[content + '目标'] = target
							item[content + '进度'] = (item[targetcolumn.field] / target * 100).toFixed(2) + '%'
						}
					}
				})
				//console.log(this.tableData)
				
				
			},
			
			
			
			
			downloadcurentday() {
				let data = []
				this.$api.BIsummary.downcurrentday({
					date: this.downloaddate / 1000
				}).then((res) => {
					res.forEach((item) => {
						data.push({
							psnNickName: item.psnNickName,
							shopname: item.shopname,
							validReplyUv1d: item.validReplyUv1d,
							fstReplyDur1d: item.fstReplyDur1d,
							avgReplyDur1d: item.avgReplyDur1d,
							dateId: item.dateId
						})
					})

					this.$refs.bisummary.exportData({
						filename: '客服绩效',
						type: 'xlsx',
						isHeader: true,
						isFooter: false,
						columns: ['psnNickName', 'shopname', 'validReplyUv1d', 'fstReplyDur1d',
							'avgReplyDur1d', 'dateId'
						],
						data: data
					})
					//console.log(data)
				})
			},
			currrentdate() {
				let today = new Date()
				let currentTimestamp = today.getTime()
				let preday1 = 24 * 60 * 60 * 1000 * 1
				preday1 = currentTimestamp - preday1
				today = new Date(preday1)
				let firstmonth = new Date(today.getFullYear(), today.getMonth(), 1)
				firstmonth = firstmonth.getTime()
				this.formData.date = [firstmonth, preday1]
				this.downloaddate = preday1
			},
			footerMethod({
				data,
				columns
			}) {
				//console.log(columns)
				let validReplyUv1d = 0
				let cstUsrCnt1d = 0
				//let ordUsrCnt1d = 0
				let ordUsrCntFinalNd = 0
				let ordAmt1d = 0
				let payUsrCnt1d = 0
				let payAmt1d = 0
				// let payItmCnt1d = 0
				let payCnt1d = 0
				// let proportionCss = 0
				let rfdAmt1d = 0
				let realPayAmt1d = 0
				let fstReplyDur1d = 0
				let avgReplyDur1d = 0
				let allCstSftRate = 0
			
				let resLevel5Cnt1d = 0
				let resLevel4Cnt1d = 0
				let resRecvEvaCnt1d = 0
			
				data.forEach((item) => {
					validReplyUv1d += item.validReplyUv1d ? parseFloat(item.validReplyUv1d) : 0
					fstReplyDur1d += item.fstReplyDur1d * item.validReplyUv1d
					avgReplyDur1d += item.avgReplyDur1d * item.validReplyUv1d
					resLevel5Cnt1d += item.resLevel5Cnt1d ? parseFloat(item.resLevel5Cnt1d) : 0
					resLevel4Cnt1d += item.resLevel4Cnt1d ? parseFloat(item.resLevel4Cnt1d) : 0
					resRecvEvaCnt1d += item.resRecvEvaCnt1d ? parseFloat(item.resRecvEvaCnt1d) : 0
					cstUsrCnt1d += item.cstUsrCnt1d ? parseFloat(item.cstUsrCnt1d) : 0
					ordUsrCntFinalNd += item.ordUsrCntFinalNd ? parseFloat(item.ordUsrCntFinalNd) : 0
					ordAmt1d += item.ordAmt1d ? parseFloat(item.ordAmt1d) : 0
					payUsrCnt1d += item.payUsrCnt1d ? parseFloat(item.payUsrCnt1d) : 0
					payAmt1d += item.payAmt1d ? parseFloat(item.payAmt1d) : 0
					// payItmCnt1d += item.payItmCnt1d ? parseFloat(item.payItmCnt1d) : 0
					payCnt1d += item.payCnt1d ? parseFloat(item.payCnt1d) : 0
					// proportionCss += item.proportionCss ? parseFloat(item.proportionCss) : 0
					rfdAmt1d += item.rfdAmt1d ? parseFloat(item.rfdAmt1d) : 0
					realPayAmt1d += item.realPayAmt1d ? parseFloat(item.realPayAmt1d) : 0	
					allCstSftRate += item.allCstSftRate ? parseFloat(item.allCstSftRate) : 0
				})
				let footer = {
					departmentid: '合计',
					psnNickName: '-',
					validReplyUv1d: validReplyUv1d,
					cstUsrCnt1d: cstUsrCnt1d,
					ordUsrCntFinalNd: ordUsrCntFinalNd,
					ordAmt1d: ordAmt1d.toFixed(2),
					payUsrCnt1d: payUsrCnt1d,
					payAmt1d: payAmt1d.toFixed(2),
					payCnt1d: payCnt1d,
					rfdAmt1d: rfdAmt1d.toFixed(2),
					realPayAmt1d: realPayAmt1d.toFixed(2),
					fstReplyDur1d: (fstReplyDur1d / validReplyUv1d).toFixed(2),
					avgReplyDur1d: (avgReplyDur1d / validReplyUv1d).toFixed(2),
					conversionrate: (ordUsrCntFinalNd / cstUsrCnt1d * 100).toFixed(2),
					allCstSftRate: (allCstSftRate / data.length).toFixed(2),
					resLevel5Cnt1d:resLevel5Cnt1d,
					resLevel4Cnt1d: resLevel4Cnt1d,
					resRecvEvaCnt1d: resRecvEvaCnt1d,
	
				}
				let showFooter = []
				columns.forEach((item) => {
					if (footer[item.field]) {
						showFooter.push(footer[item.field])
					}else{
						showFooter.push('')
					}
				})
				//console.log(showFooter,123123)
				return [
					showFooter
				]
			},
			submitEvent() {
				this.list()
			},
			reset() {
				for (let i in this.formData) {
					this.formData[i] = null
				}
				this.currrentdate()
				this.formData.shopname = []
				this.childrenRow = null
				this.list()
			},
			headerCellClickEvent(e) {
				let filterIndex = this.filterField.findIndex((item) => {
					return item == e.column.field
				})
				if (filterIndex === -1) {
					if (!e.triggerSort) {
						this.chartField = e.column.field
						this.chartTitle = e.column.title
						this.createChart()
					}
				}
			},
			cellClickEvent({
				row
			}) {
				if (!row.ischild) {
					this.loadChildrenMethod({
						row: row
					}).then((childrenRow) => {
						this.childrenRow = childrenRow
						this.$nextTick(() => {
							this.$refs.statisticsChart.createChart()
						})
					})
				}
			},
			createChart() {
				this.tableData = this.createTableData()
				//console.log(this.tableData)
				this.$nextTick(() => {
					this.$refs.statisticsChart.createChart()
				})
			}
		},
		components: {
			datePicker,
			statisticsChart,
			trendChart,
			performanceIndex,
			clickfarmingIndex,
			stafftreeIndex
		}
	}
</script>